<template>
  <VueEditor
    :editor-toolbar="customToolbar"
    v-model="inputVal"
    :placeholder="$t('taskAssignment.additional_content.placeholder')"
  >
  </VueEditor>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
      ],
    };
  },

  props: {
    value: {
      required: false,
    },
  },

  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
